import { EyeOutlined } from '@ant-design/icons'
import { Button, Space } from 'antd'
import ButtonGroup from 'antd/es/button/button-group'
import { FC } from 'react'
import PreviewShipmentBlank from '../../../../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import Machine from '../../../../../../types/api/machine'
import RewindJob from '../../../../../../types/api/rewind-job'
import AddToMachineQueue from './add-to-machine-queue/add-to-machine-queue'

interface ActionsCellProps {
    rewindJob: RewindJob
    machines: Machine[]
}

const ActionsCell: FC<ActionsCellProps> = ({ rewindJob, machines }) => {
    const shipment = rewindJob.shipment

    if (!shipment) return null

    return (
        <Space>
            <ButtonGroup>
                <PreviewShipmentBlank
                    shipment={shipment}
                    blankType='production'
                    blankPreviewFiles={shipment.blankPreviewFiles}
                >
                    <Button
                        title='Посмотреть бланк'
                        size='small'
                        icon={<EyeOutlined />}
                        color='magenta'
                        variant='solid'
                    />
                </PreviewShipmentBlank>
            </ButtonGroup>
            <AddToMachineQueue rewindJob={rewindJob} machines={machines} />
        </Space>
    )
}

export default ActionsCell
